import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { ICanActivateOverlays } from '../models/CanActivate';
import { NativeStorageNamesV2 } from '../models/Constants';
import { FiltroPipe } from '../pipes/filtro.pipe';
import { OverlayService } from '../services/overlays/overlay.service';
import { SharedServiceService } from '../services/shared-service.service';
import { StorageData } from '../services/utilities/storage-data.class';

@Injectable({
  providedIn: 'root'
})
export class CanActivateOverlayGuard implements CanActivate {

  constructor(
    private sharedService: SharedServiceService
    , private filter: FiltroPipe
    , private overlayS: OverlayService
  ) {
  }

  async canActivate(
    next: ActivatedRouteSnapshot
    , state: RouterStateSnapshot
  ) {

    await this.overlayS.onDismissOverlay()

    const path = next.routeConfig.path
    const dataOverlys: ICanActivateOverlays[] = await StorageData.getDataStorage(NativeStorageNamesV2.OverlaysModulos)

    if (dataOverlys) {
      const overlay: ICanActivateOverlays[] = this.filter.transform(dataOverlys, path, 'Ruta')
      const objectOverlay: ICanActivateOverlays = overlay.length > 0 ? overlay[0] : null

      if (objectOverlay) {
        await this.overlayS.firstTimeOverlay('', path, objectOverlay, 1500)
      }
    } else if (path === 'login') {
      const objectOverlay = {
        Ruta: 'login',
        Imagen: 'Images/overlays/overlay_login_1.png',
        Texto_Boton: 'Entendido',
        Posicion_Boton: {
          position: 'absolute', bottom: '18px', left: 'calc(50% - 62px)'
          , 'background-color': '#ffc40c', 'border-radius': '5px', 'font-size': '16px', 'text-transform': 'capitalize'
        },
        FechaEdicion: '2020-07-14 00:00:00'
      }
      await this.overlayS.firstTimeOverlay('', path, objectOverlay, 1500)
    }

    return true
  }

}
